export interface SalesDocumentConnection {
    id?: number;
    uuid: string;
    salesDocumentId: string;
    buyDocumentId: string;
    salesPositionId?: string | null;
    buyPositionId?: string | null;
    salesAttachmentId?: string | null;
    buyAttachmentId?: string | null;
    isDeleted?: boolean;
    /** Czy oczekuje na zapis */
    $dirty?: boolean;

    $del?: number;
    /**
     * Czas utworzenia dokumentu na serwerze
     */
    createdServer?: Date;

    /**
     * Czas modyfikacji dokumentu na serwerze
     */
    modifiedServer?: Date;
}

export type SalesDocumentConnectionDto = Omit<SalesDocumentConnection, '$dirty' | 'createdServer' | 'modifiedServer'>;

export type SalesDocumentConnections = {
    [salesDocumentId: string]: {
        [buyDocumentId: string]: {
            [uuid: string]: SalesDocumentConnection
        }
    }
};

export function flattenConnections(connections: SalesDocumentConnections): SalesDocumentConnection[] {
    const array: SalesDocumentConnection[] = [];
    for (const docId in connections) {
        if (connections[docId]) {
            for (const buyDocId in connections[docId]) {
                if (connections[docId][buyDocId]) {
                    for (const uuid in connections[docId][buyDocId]) {
                        if (connections[docId][buyDocId][uuid]) {
                            array.push(connections[docId][buyDocId][uuid]);
                        }
                    }
                }
            }
        }
    }
    return array;
}